import React, { useMemo } from "react";
import { Form, Row, Col, FormGroup, Label } from "reactstrap";
import { useTranslation } from "react-i18next";
import Select from "components/Select";
import { getActiveColorStyle } from "utils/colorUtils";
import {
  getTheme2SearchFilterColProps,
  getTheme2SearchFilterSingleSelectStyles,
} from "utils/theme2MultiSelect";

const SALogsFilters = ({
  activeColor = "secondary",
  isTheme2 = false,
  userIdFilter,
  onUserIdFilterChange,
  tenantFilter,
  onTenantFilterChange,
  userOptions = [],
  tenantOptions = [],
}) => {
  const { t } = useTranslation();
  const activeColorStyle = useMemo(() => getActiveColorStyle(activeColor), [activeColor]);
  const filterSelectStyles = useMemo(
    () => getTheme2SearchFilterSingleSelectStyles(activeColorStyle, isTheme2),
    [activeColorStyle, isTheme2]
  );
  const filterColProps = getTheme2SearchFilterColProps(isTheme2, {
    filterColClass: "search-sa-logs-filter-col",
    md: "4",
  });

  return (
    <Form>
      <Row className={isTheme2 ? "search-sa-logs-filters-row" : "mb-3"}>
        <Col {...filterColProps}>
          <FormGroup>
            <Label>{t("reports.filterByUser") || "Filter by User"}:</Label>
            <Select
              activeColor={activeColor}
              className="react-select w-100"
              styles={filterSelectStyles}
              placeholder={t("reports.filterByUser") || "Select User..."}
              name="userFilter"
              isSearchable
              isClearable
              closeMenuOnSelect={true}
              value={userIdFilter}
              onChange={(option) => onUserIdFilterChange(option)}
              options={userOptions}
            />
          </FormGroup>
        </Col>
        <Col {...filterColProps}>
          <FormGroup>
            <Label>{t("searchInventory.tenant")}:</Label>
            <Select
              activeColor={activeColor}
              className="react-select w-100"
              styles={filterSelectStyles}
              placeholder={t("searchInventory.tenant")}
              name="tenantFilter"
              isSearchable
              isClearable
              closeMenuOnSelect={true}
              value={tenantFilter}
              onChange={(option) => onTenantFilterChange(option)}
              options={tenantOptions}
            />
          </FormGroup>
        </Col>
      </Row>
    </Form>
  );
};

export default SALogsFilters;
